import { render } from "./PasswordRestorePage.vue?vue&type=template&id=3b35c092"
import script from "./PasswordRestorePage.vue?vue&type=script&lang=js"
export * from "./PasswordRestorePage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PasswordRestorePage.vue?vue&type=style&index=0&id=3b35c092&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__